<template>
  <div id="aside"
       class="flex ac">
    <img src="./img/side/logo_1.png"
         class="logo"/>
    <div class="aside_split"></div>
    <div class="side_menu scroll">
      <div :class="['item',$route.path.indexOf('square')>-1?'active':'link']"
           @click="handleJump('/square')">
        <div class="item_icon">
          <div class="left_line"></div>
          <img class="icon_img" src="./img/side/logo.png" alt=" "/>
          <div class="right_line"></div>
        </div>
        <p class="item_name">视频广场</p>
      </div>
      <div :class="['item',$route.path.indexOf('video')>-1?'active':'link']"
           @click="handleJump('/video')">
        <div class="item_icon">
          <div class="left_line"></div>
          <div class="img_wrap">
            <img class="icon_img" src="./img/side/Runway.png" alt=" "/>
            <img class="icon_img icon_img-bright" src="./img/side/Runway-1.png" alt=" "/>
          </div>
          <div class="right_line"></div>
        </div>
        <p class="item_name">Runway</p>
      </div>
      <div :class="['item',$route.path.indexOf('Sora')>-1?'active':'link']"
           @click="handleJump('/Sora')">
        <div class="item_icon">
          <div class="left_line"></div>
          <div class="img_wrap">
            <img class="icon_img icon_img_sora" src="./img/side/sora_logo.gif" alt=" "/>
            <img class="icon_img icon_img-bright icon_img_sora_act" src="./img/side/sora_logo.gif" alt=" "/>
          </div>
          <div class="right_line"></div>
        </div>
        <p class="item_name">Sora 2</p>
      </div>
      <div :class="['item',$route.path.indexOf('pika')>-1?'active':'link']"
           @click="handleJump('/pika')">
        <div class="item_icon">
          <div class="left_line"></div>
          <div class="img_wrap">
            <img class="icon_img" src="./img/side/Pika.png" alt=" "/>
            <img class="icon_img icon_img-bright" src="./img/side/Pika-1.png" alt=" "/>
          </div>
          <div class="right_line"></div>
        </div>
        <p class="item_name">Pika</p>
      </div>
      <div :class="['item',$route.path.indexOf('luma')>-1?'active':'link']"
           @click="handleJump('/luma')">
        <div class="item_icon">
          <div class="left_line"></div>
          <div class="img_wrap">
            <img class="icon_img" src="./img/side/Luma.png" alt=" "/>
            <img class="icon_img icon_img-bright" src="./img/side/Luma-1.png" alt=" "/>
          </div>
          <div class="right_line"></div>
        </div>
        <p class="item_name">Luma</p>
      </div>
      <div :class="['item',$route.path.indexOf('Viggle')>-1?'active':'link']"
           @click="handleJump('/Viggle')">
        <div class="item_icon">
          <div class="left_line"></div>
          <div class="img_wrap">
            <img class="icon_img" src="./img/side/Vigg.png" alt=" "/>
            <img class="icon_img icon_img-bright" src="./img/side/Vigg-1.png" alt=" "/>
          </div>
          <div class="right_line"></div>
        </div>
        <p class="item_name">Viggle</p>
      </div>

      <!-- 860 -->
      <el-popover placement="right-end" width="1025" trigger="hover"
                  :visible-arrow="true" popper-class="video_popup1">
        <div class="video_poppanel">
          <div class="panel_tabs">
            <div class="tab_item" v-for="(item,index) in video_tabs1"
                 @click="goVideo(item,1)">
              <div class="tab_icon"
                   :style="{'background-image': `url(${item.img})`
                   ,'--gif-url':`url(${item.img2})
                   `}"></div>
              <div class="tab_text">
                {{ item.name }}
              </div>
            </div>
            <div class="tab_item" v-for="(item,index) in video_tabs2"
                 @click="goVideo(item,2)">
              <div class="tab_icon"
                   :style="{'background-image': `url(${item.img})`
                   ,'--gif-url':`url(${item.img2})
                   `}"></div>
              <div class="tab_text">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="item" :class="['item',$route.path.indexOf('Anime')>-1||$route.path.indexOf('Face')>-1?'active':'link']" slot="reference"-->
        <!--             @click="handleJump('/Face?plan=Face')">-->
        <div class="item" @click="handleJump('/Face?plan=Face')"
             :class="['item',$route.path.indexOf('Anime')>-1||$route.path.indexOf('Face')>-1?'active':'link']"
             slot="reference">
          <div class="item_icon">
            <div class="left_line"></div>
            <div class="img_wrap">
              <img class="icon_img " src="./img/side/tools-gary.png" alt=" "/>
              <img class="icon_img icon_img-bright" src="./img/side/tools.png" alt=" "/>
            </div>
            <div class="right_line"></div>
          </div>
          <div class="item_name">
            <div class="red_box"></div>
            工具箱
          </div>
        </div>
      </el-popover>
      <div class="box_bottom" v-if="box_bottom">
        <div>
        </div>
        新增视频转动漫等10款Ai视频工具！ <span @click="newBox('关闭')">关闭提醒（{{ time_num }}S）</span>
      </div>
      <!--      <el-tooltip class="item" effect="dark" content="Bottom Left 提示文字" placement="bottom-start">-->
      <!--        <el-button>下左</el-button>-->
      <!--      </el-tooltip>-->
    </div>
    <div class="side_menu">
      <div class="item"
           @click="show_open">
        <img src="./img/side/icon_img3.png"
             alt=" "/>
        <p class="item_name">会员</p>
      </div>
      <div class="item"
           @click="handleJump('/favorites')">
        <img src="./img/side/icon_img4.png"
             alt=" "/>
        <p class="item_name">视频夹</p>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  data() {
    return {
      video_tabs1: [
        {
          name: '视频转动漫', tag: 'Anime', types: 1,
          img: require('./img/side/kelingTool/11.jpg'),
          img2: require('./img/side/kelingTool/11.gif'),
        },
        {
          name: '视频换脸', tag: 'Face', types: 2,
          img: require('./img/side/kelingTool/12.jpg'),
          img2: require('./img/side/kelingTool/12.gif'),
        },
      ],
      video_tabs2: [
        {
          name: '花花世界  ',
          tag: 'kelingTool',
          tag2: 'bloombloom',
          types: '/kelingTool?plan=bloombloom&loca=1',
          img: require('./img/side/kelingTool/01.webp'),
          img2: require('./img/side/kelingTool/01.gif'),
        },
        {
          name: '魔力转圈圈',
          tag: 'kelingTool',
          tag2: 'dizzydizzy',
          types: '/kelingTool?plan=dizzydizzy&loca=2',
          img: require('./img/side/kelingTool/02.webp'),
          img2: require('./img/side/kelingTool/02.gif'),
        },
        {
          name: '快来惹毛我',
          tag: 'kelingTool',
          tag2: 'fuzzyfuzzy',
          types: '/kelingTool?plan=fuzzyfuzzy&loca=3',
          img: require('./img/side/kelingTool/03.webp'),
          img2: require('./img/side/kelingTool/03.gif'),
        },
        {
          name: '捏捏乐   ',
          tag: 'kelingTool',
          tag2: 'squish',
          types: '/kelingTool?plan=squish&loca=4',
          img: require('./img/side/kelingTool/04.webp'),
          img2: require('./img/side/kelingTool/04.gif'),
        },
        {
          name: '万物膨胀 ',
          tag: 'kelingTool',
          tag2: 'expansion',
          types: '/kelingTool?plan=expansion&loca=5',
          img: require('./img/side/kelingTool/05.webp'),
          img2: require('./img/side/kelingTool/05.gif'),
        },
        {
          name: '一键变手办 ',
          tag: 'kelingTool',
          tag2: 'Labubu Style',
          types: '/kelingTool?plan=Labubu Style&loca=5',
          img: require('./img/side/kelingTool/06.webp'),
          img2: require('./img/side/kelingTool/06.gif'),
        },
        {
          name: '一键拍立得 ',
          tag: 'kelingTool',
          tag2: 'Magic Polaroid',
          types: '/kelingTool?plan=Magic Polaroide&loca=5',
          img: require('./img/side/kelingTool/07.webp'),
          img2: require('./img/side/kelingTool/07.gif'),
        },
        {
          name: '拥抱    ',
          tag: 'kelingTool',
          tag2: 'hug',
          types: '/kelingTool?plan=hug&loca=6',
          img: require('./img/side/kelingTool/08.webp'),
          img2: require('./img/side/kelingTool/08.gif'),
        },
        {
          name: '亲吻    ',
          tag: 'kelingTool',
          tag2: 'kiss',
          types: '/kelingTool?plan=kiss&loca=7',
          img: require('./img/side/kelingTool/09.webp'),
          img2: require('./img/side/kelingTool/09.gif'),
        },
        {
          name: '比心    ',
          tag: 'kelingTool',
          tag2: 'heart_gesture',
          types: '/kelingTool?plan=heart_gesture&loca=8',
          img: require('./img/side/kelingTool/10.webp'),
          img2: require('./img/side/kelingTool/10.gif'),
        },
      ],
      box_bottom: false,
      time_num: 9,
      intervalId: null,
      urlName: '',
    }
  },

  created() {
    this.newBox()
    this.urlName = this.$route.path
  },
  mounted() {

  },
  computed:{
    isLogin() {
      return this.$store.state.isLogin;
    },
    kelingTool() {
      return this.$store.state.kelingTool;
    },
  },
  methods: {
    handleJump(url) {
      // this.checkKehuTip()
      this.$router.push(url)
      // if (this.$route.path != url) this.$router.push(url)
      // if (this.urlName == '') {
      //   this.urlName = url
      //   this.$router.push(url)
      // } else {
      //   if (url != this.urlName) {
      //     this.urlName = url
      //     this.$router.push(url)
      //   }
      // }
    },
    checkKehuTip() {
      if (!this.$store.state.isLogin) return
      if (!this.$store.state.userInfo.vip_type) return
      // if(localStorage.getItem('clientDownDate')){
      //   this.$store.commit('showKehuTip', false)
      //   return
      // }
      if (localStorage.getItem('kehuTip')) {
        this.checkTimestamp()
        return
      }
      this.$store.commit('showKehuTip', true)
    },
    checkTimestamp() {
      // if(localStorage.getItem('kehuTip')){
      let kehuInfo = localStorage.getItem('kehuTip')
      kehuInfo = JSON.parse(kehuInfo)
      let start_time = kehuInfo.time
      const STORAGE_KEY = 'kehuTip';
      const TWELVE_HOURS = 24 * 60 * 60 * 1000; // 12小时的毫秒数
      const TWELVE_HOURS2 = 168 * 60 * 60 * 1000; // 7天的毫秒数

      const currentTime = Date.now();

      // 计算时间差
      const timeDiff = currentTime - parseInt(start_time, 10);
      let clientDownDate = localStorage.getItem('clientDownDate') || 0
      // 超过12小时执行操作
      if ((timeDiff >= TWELVE_HOURS) && !clientDownDate) {
        this.$store.commit('showKehuTip', true)
        // localStorage.setItem(STORAGE_KEY, currentTime); // 更新存储时间
      } else if ((timeDiff >= TWELVE_HOURS2) && clientDownDate) {
        this.$store.commit('showKehuTip', true)
      }
      // }
    },
    show_open() {
      // this.$store.commit('setShowOpen', true)
      // this.$router.push("/member");
      if(!this.$store.state.isLogin){
        this.$store.commit('setShowLogin', true)
        return
      }
      this.$store.commit('setisPayPopShow', true)
    },
    goVideo(type, index) {
      // this.handleJump('/toolbox')
      // console.log(this.$route.query.plan =='face')

      // console.log('this.$route', this.$route);
      // console.log('this.kelingTool', this.kelingTool);
      if (index == 1) {
        if (this.$route.query.plan == type.tag) {
          return
        }
        this.$router.push({
          path: type.tag,
          query: {plan: type.tag2,}
        })
      } else {
        if (this.$route.path == '/kelingTool') {
          if (this.kelingTool == type.tag2) {
            return
          }
          this.$store.commit('setkelingTool', type.tag2);
        } else {
          this.$router.push({
            path: type.tag,
          })
          this.$store.commit('setkelingTool', type.tag2);
        }
      }
    },
    //定时器
    fixedtime() {
      // 创建定时器
      this.intervalId = setInterval(() => {
        this.time_num--
        // console.log(11111)
        if (this.time_num == 0) {
          this.box_bottom = false
          clearInterval(this.intervalId);
        }
      }, 1000);
    },
    newBox(click) {
      // this.box_bottom = true
      const now = new Date();
      // const month = now.getMonth() + 1; // getMonth() 返回的月份是从0开始的，所以需要加1
      const day = now.getDate();
      let time = {pass: true, times: day}
      // 存储在本地
      // localStorage.setItem('month_day', JSON.stringify(time));
      // 获取本地month_day
      const storedMonthDay = localStorage.getItem('month_day');
      // 判断本地month_day是否为空
      if (storedMonthDay) {
        let local = JSON.parse(storedMonthDay)
        if (click === '关闭') {
          this.box_bottom = false
          local.pass = false
          local.times = day
          localStorage.setItem('month_day', JSON.stringify(local));
        } else {
          if (day == 1 || day > local.times) {
            this.box_bottom = true
            localStorage.setItem('month_day', JSON.stringify(time));
            this.fixedtime()
          } else {
            if (local.pass == true) {
              this.box_bottom = true
              this.fixedtime()
            } else {
              local.pass = false
              local.times = day
              localStorage.setItem('month_day', JSON.stringify(local));
            }
          }
        }
      } else {
        localStorage.setItem('month_day', JSON.stringify(time));
        this.box_bottom = time.pass
        // 定时器
        this.fixedtime()
      }

    },
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#aside {
  width: 70px;
  flex-direction: column;
  flex-shrink: 0;
  overflow: hidden;
  padding: 4px 0;
  font-size: 12px;

  .logo {
    width: 48px;
    height: 48px;
    border-radius: 24px;
    margin-left: 5px;
  }

  .aside_split {
    margin-top: 15px;
    margin-bottom: 15px;
    width: 32px;
    height: 2px;
    background-color: #35363c;
  }

  .side_menu {
    .item {
      cursor: pointer;

      &.active {
        .item_icon {
          .left_line {
            background-color: #fff;
          }

          .img_wrap {
            .icon_img-bright {
              z-index: 11;
            }
          }
        }

        .item_name {
          color: #fff;
          font-weight: bold;

        }
      }

      &.link .item_icon {
        &:hover .left_line {
          height: 18px;
          background-color: #fff;
          animation: checked-animation .5s linear;
        }
      }

      .item_icon {
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        &:hover {
          .img_wrap {
            .icon_img-bright {
              z-index: 11;
            }
          }
        }

        .left_line {
          height: 36px;
          width: 4px;
          border-radius: 0 4px 4px 0;
          animation: checkeding-animation .5s linear;
        }

        .img_wrap {
          position: relative;
          display: flex;

          .icon_img-bright {
            z-index: 9;
            position: absolute;
            left: 0;
            top: 0;

            &:hover {
              border-radius: 12px;
              animation: img-animation .5s linear;
            }
          }
        }
      }

      .icon_img {
        position: relative;
        z-index: 10;
        width: 48px;
        height: 48px;
        border-radius: 24px;
        border: none;
      }
      .icon_img_sora, .icon_img_sora_act{
        width: 48px;
        height: 48px;
        background: #313338;
        padding: 7px 5px 5px 7px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .icon_img_sora_act{
        background: rgb(88, 101, 242);
      }

      .item_name {
        margin-bottom: 15px;
        color: #b4b9bf;
        text-align: center;
        position: relative;
        .red_box {
          width: 5px;
          height: 5px;
          top: 3px;
          right: 5px;
          background-color: #ff1e10;
          border-radius: 9999px;
          position: absolute;
          box-sizing: border-box;
        }

      }
    }

    &.scroll {
      flex: 1 1 0%;
      overflow-y: auto;
      width: 100%;
    }
  }


}

.video_poppanel {
  color: #fff;

  .panel_title {
    font-weight: 700;
    margin-bottom: 8px;
  }

  .panel_tabs {
    display: flex;
    flex-wrap: wrap;
    //width: 308px;
    gap: 24px;

    .tab_item:hover .tab_icon {
      background-image: var(--gif-url) !important;
    }

    .tab_item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 140px;
      height: 140px;
      background-color: #000;
      border-radius: 10px;
      border: 2px solid #000;
      cursor: pointer;
      position: relative;
      overflow: hidden;

      &:hover {
        border-color: rgb(88, 101, 242);
      }

      .tab_icon {
        //width: 140px;
        //height: auto;
        position: absolute;
        width: 100%;
        height: 100%;
        transition: opacity 0.3s ease;
        background-size: 100% 100%;
        //display: block;
        //border: none;
        //object-fit: contain;
      }

      .tab_text {
        position: absolute;
        bottom: 0;
        width: 100%;
        //height: 64px;
        padding: 10px;
        background: linear-gradient(180deg, #0f0f0f00, #0f0f0f);
        text-align: center;
        line-height: 1;
      }

    }
  }
}

.box_bottom {
  z-index: 99999999;
  position: fixed;
  //bottom: 225px;
  left: 15px;
  background-color: #fff;
  padding: 5px 1px 5px 10px;
  border-radius: 5px;
  box-shadow: 0 0 5px 0 #ddd;
  font-size: 14px;
  color: #555;

  span {
    color: red;
    cursor: pointer;
    margin-left: 20px;
  }

  div {
    z-index: -9;
    width: 10px;
    height: 10px;
    background-color: #fff;
    //box-shadow: 0 0 5px 0 #ddd;
    position: absolute;
    top: -5px;
    left: 15px;
    transform: rotate(45deg);
  }
}

@keyframes img-animation {
  0% {
    border-radius: 24px;
  }

  50% {
    border-radius: 18px;
  }
  100% {
    border-radius: 12px;
  }
}

@keyframes checked-animation {
  0% {
    height: 0;
  }
  50% {
    height: 9px;
  }
  100% {
    height: 18px;
  }
}

@keyframes checkeding-animation {
  0% {
    height: 18px;
  }
  50% {
    height: 27px;
  }
  100% {
    height: 36px;
  }
}
</style>
<style lang="scss">
.video_popup1 {
  background-color: #3f3c3a !important;
  border: 2px solid #b2b7bd !important;
  //box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.3) !important;
  margin-left: -10px;
  padding: 18px 24px 24px !important;
  border-radius: 10px !important;
}
.popper__arrow{
  border-right-color: rgba(0, 0, 0, 0) !important;
}

.video_popup1 .popper__arrow::after {
  bottom: 10px !important;
  left: -2px !important;
  border-right-color: #b2b7bd !important;
  border-left-width: 0 !important;
}
</style>